import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
import { ScrollToTop } from './components/ScrollToTop';
// Pages
import { HomePage } from './pages/HomePage';
import { AboutPage } from './pages/AboutPage';
import { ServicesPage } from './pages/ServicesPage';
import { RentalsPage } from './pages/RentalsPage';
import { GalleryPage } from './pages/GalleryPage';
import { IndustriesPage } from './pages/IndustriesPage';
import { ContactPage } from './pages/ContactPage';
export function App() {
  return <HashRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col bg-brand-black text-brand-muted-light font-sans selection:bg-brand-blue/30 selection:text-white" data-id="element-2">
        <Header data-id="element-3" />

        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            <Route path="/about" element={<AboutPage data-id="element-9" />} data-id="element-8" />
            <Route path="/services" element={<ServicesPage data-id="element-11" />} data-id="element-10" />
            <Route path="/rentals" element={<RentalsPage data-id="element-13" />} data-id="element-12" />
            <Route path="/gallery" element={<GalleryPage data-id="element-15" />} data-id="element-14" />
            <Route path="/industries" element={<IndustriesPage data-id="element-17" />} data-id="element-16" />
            <Route path="/contact" element={<ContactPage data-id="element-19" />} data-id="element-18" />
          </Routes>
        </div>

        <Footer data-id="element-20" />
        <WhatsAppButton data-id="element-21" />
      </div>
    </HashRouter>;
}